import React from "react";

export default function(Component) {
  var klass = class Pure extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
    render() {
      return <Component {...this.props} />;
    }
  };
  klass.displayName = "Pure(" + Component.name + ")"; // eslint-disable-line react/static-property-placement
  return klass;
}
